/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import localStorageMethods from "helpers/localStorage";
import * as CognitoService from "features/authDashboard/service/cognito";
import { useDispatch } from "react-redux";
import { resetState } from "features/authDashboard/slices/signIn.slice";

function ProtectedRoute({ children }: { children: JSX.Element }) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validateCognitoToken = async (token: string) => {
    try {
      const username = localStorageMethods.getItemFromLocalStorage("username");
      const isVerified = await CognitoService.verifyUser(username, token);
      return isVerified;
    } catch (err) {
      return false;
    }
  };

  useEffect(() => {
    const authenticateSession = async () => {
      const accessToken = localStorageMethods.getItemFromLocalStorage("accessToken");
      if (!accessToken || ! await validateCognitoToken(accessToken)) {
        dispatch(resetState());
        localStorageMethods.emptyLocalStorage();
        navigate("/");
      }
    };
    authenticateSession();
  }, [location]);
  return children;
}

export default ProtectedRoute;
